import i18next, {} from "i18next";
import { initReactI18next } from "react-i18next";
import enUS from "./locales/en-US/index";
export const NAMESPACES = Object.keys(enUS);
/*
  One explicit loader per translated locale so the bundler emits one chunk per
  locale. No glob or template-string imports: shared is built by tsc, not Vite.
*/
const LOADERS = {
    "da-DK": () => import("./locales/da-DK/index"),
    "de-DE": () => import("./locales/de-DE/index"),
    "es-ES": () => import("./locales/es-ES/index"),
    "fr-FR": () => import("./locales/fr-FR/index"),
    "pt-PT": () => import("./locales/pt-PT/index"),
    "it-IT": () => import("./locales/it-IT/index"),
    "tr-TR": () => import("./locales/tr-TR/index"),
};
/** The single instance. Apps import hooks from this module, never from react-i18next. */
export const i18n = i18next;
let initPromise = null;
/**
 * English is inline and always present; a translated locale is fetched on top
 * before the instance initialises, so the first render is already in the
 * right language. A loader failure logs and renders English. Repeat calls
 * (tests, HMR) reuse the first init. With `initAsync: false` and inline
 * resources, `initI18n("en-US")` has finished by the time it returns.
 */
export const initI18n = (locale) => {
    if (initPromise)
        return initPromise;
    const resources = { "en-US": enUS };
    const init = () => {
        i18n.use(initReactI18next).init({
            resources,
            lng: locale,
            fallbackLng: "en-US",
            defaultNS: "common",
            ns: NAMESPACES,
            keySeparator: ".",
            nsSeparator: ":",
            returnNull: false,
            interpolation: { escapeValue: false },
            react: { useSuspense: false },
            initAsync: false,
        });
    };
    const load = LOADERS[locale];
    if (!load) {
        init();
        initPromise = Promise.resolve();
        return initPromise;
    }
    initPromise = load()
        .then((module) => {
        resources[locale] = module.default;
    })
        .catch((error) => {
        console.error(`Failed to load UI locale ${locale}, rendering English`, error);
    })
        .then(init);
    return initPromise;
};
//# sourceMappingURL=init.js.map